
<!-- Global Hero Header -->
<header class="hero-section-global">
  <div class="hero-background-global"
    style="background-image: url('https://images.ctfassets.net/f6ou4743hwzs/2xaL3IYyS5iU8bcXoWAOdX/9d1784950839614bbbcaa593c23ee090/whyblm.jpg');">
  </div>
  <div class="hero-overlay-global"></div>
  <div class="hero-content-global">
    <span class="hero-badge">Interactive History</span>
    <h1 class="hero-title-global">300+ Years on the Bayou</h1>
    <p class="hero-subtitle">
      Trace the indigenous roots, colonial brickmaking, poetic sanctuaries, and living traditions of Lacombe, Louisiana.
    </p>
  </div>
</header>

<main class="timeline-container">
  <!-- Era Filter Bar -->
  <section class="era-filter-section" aria-label="Timeline Era Filters">
    <div class="filter-scroll-wrapper">
      <button 
        *ngFor="let era of eras"
        type="button"
        class="filter-chip"
        [class.active]="selectedEra === era.id"
        (click)="filterByEra(era.id)"
        [attr.aria-pressed]="selectedEra === era.id">
        {{ era.name }}
      </button>
    </div>
  </section>

  <!-- Interactive Timeline Stream -->
  <section class="timeline-stream" aria-label="Chronological History of Lacombe">
    <div class="timeline-spine"></div>

    <article 
      *ngFor="let event of filteredEvents; let idx = index; let isOdd = odd"
      class="timeline-card-wrapper"
      [class.card-right]="isOdd"
      [class.card-left]="!isOdd"
      [class.expanded]="activeEvent === event">
      
      <!-- Center Node / Milestone Marker -->
      <div class="milestone-marker" (click)="selectEvent(event)" [attr.aria-label]="event.year + ': ' + event.title">
        <mat-icon>{{ event.icon }}</mat-icon>
      </div>

      <!-- Main Event Card -->
      <div class="timeline-card" (click)="selectEvent(event)">
        <div class="card-header">
          <div class="year-badge">{{ event.year }}</div>
          <span class="era-tag">{{ event.eraName }}</span>
        </div>

        <h2 class="card-title">{{ event.title }}</h2>
        <p class="card-summary">{{ event.summary }}</p>

        <!-- Expanded Full Story Section -->
        <div class="card-details" *ngIf="activeEvent === event">
          <p class="card-full-desc">{{ event.description }}</p>
          
          <div class="card-significance" *ngIf="event.significance">
            <strong>Historical Significance:</strong>
            <span>{{ event.significance }}</span>
          </div>

          <div class="card-image-wrap" *ngIf="event.imageUrl">
            <img [src]="event.imageUrl" [alt]="event.title" loading="lazy" />
            <span class="caption" *ngIf="event.imageCaption">{{ event.imageCaption }}</span>
          </div>
        </div>

        <!-- Toggle Read More Button -->
        <button 
          type="button" 
          class="read-more-btn"
          (click)="selectEvent(event); $event.stopPropagation()">
          <span>{{ activeEvent === event ? 'Show Less' : 'Explore Story' }}</span>
          <mat-icon>{{ activeEvent === event ? 'expand_less' : 'expand_more' }}</mat-icon>
        </button>
      </div>
    </article>
  </section>

  <!-- Next Step CTA -->
  <aside class="timeline-cta-banner">
    <div class="cta-inner">
      <h2>Experience History in Person</h2>
      <p>The 1912 schoolhouse is open every Saturday from Noon to 4 PM. Explore original artifacts, exhibits, and our grounds.</p>
      <div class="cta-actions">
        <a routerLink="/tour" class="cta-primary-btn">
          <mat-icon>navigation</mat-icon>
          Self-Guided Walking Tour
        </a>
        <a routerLink="/appointment" class="cta-secondary-btn">
          <mat-icon>calendar_today</mat-icon>
          Schedule a Private Tour
        </a>
      </div>
    </div>
  </aside>
</main>
